export default {
    name: 'Users2',
    dimensions: { width: 40, height: 40 },
    content: `
    <g fill="currentColor" stroke="none">
      <path d="M13 11C15.21 11 17 12.79 17 15C17 17.21 15.21 19 13 19C10.79 19 9 17.21 9 15C9 12.79 10.79 11 13 11ZM13 21C16.31 21 19 18.31 19 15C19 11.69 16.31 9 13 9C9.69 9 7 11.69 7 15C7 18.31 9.69 21 13 21Z"/>
      <path d="M18 23H8C3.59 23 0 26.59 0 31V39C0 39.55 0.45 40 1 40C1.55 40 2 39.55 2 39V31C2 27.69 4.69 25 8 25H18C21.31 25 24 27.69 24 31V39C24 39.55 24.45 40 25 40C25.55 40 26 39.55 26 39V31C26 26.59 22.41 23 18 23Z"/>
      <path d="M27 2C29.21 2 31 3.79 31 6C31 8.21 29.21 10 27 10C24.79 10 23 8.21 23 6C23 3.79 24.79 2 27 2ZM27 12C30.31 12 33 9.31 33 6C33 2.69 30.31 0 27 0C23.69 0 21 2.69 21 6C21 9.31 23.69 12 27 12Z"/>
      <path d="M32 14H22C21.45 14 21 14.45 21 15C21 15.55 21.45 16 22 16H32C35.31 16 38 18.69 38 22V30C38 30.55 38.45 31 39 31C39.55 31 40 30.55 40 30V22C40 17.59 36.41 14 32 14Z"/>
    </g>
  `
};
